import { agent_url, sub_urls, stage_url } from "../api-urls";
import axios from "axios";
import Headers from "./Headers";

export const AgentApi = {
  createSession: async (userId) => {
    const response = await axios.post(
      stage_url + sub_urls.agent.newSession,
      {},
      {
        params: { userId },
        headers: Headers.getHeaders(),
      }
    );
    return response;
  },

  sendChat: async ({ userId, sessionId, message }) => {
    const response = await axios.post(
      stage_url + sub_urls.agent.chat,
      { userId, sessionId, message },
      {
        headers: Headers.getHeaders(),
      }
    );
    return response;
  },
};
